module.exports = {"500107001":"杨家坪街道","500107002":"黄桷坪街道","500107003":"谢家湾街道","500107004":"石坪桥街道","500107005":"石桥铺街道","500107006":"中梁山街道","500107007":"渝州路街道","500107008":"二郎街道","500107100":"九龙镇","500107102":"华岩镇","500107103":"含谷镇","500107104":"金凤镇","500107105":"白市驿镇","500107106":"走马镇","500107107":"石板镇","500107108":"巴福镇","500107109":"陶家镇","500107110":"西彭镇","500107111":"铜罐驿镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500107.json
// module id = 2041
// module chunks = 0